import Vue from 'vue';
import Vuex from 'vuex';
import profile from './profile.module';
import htmlClass from './htmlclass.module';
import system from './system.module';
import search from './search.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    system,
    profile,
    htmlClass,
    search,
  },
});
